import { render, staticRenderFns } from "./issueKanban.vue?vue&type=template&id=065b9136&scoped=true"
import script from "./issueKanban.vue?vue&type=script&lang=js"
export * from "./issueKanban.vue?vue&type=script&lang=js"
import style0 from "./issueKanban.vue?vue&type=style&index=0&id=065b9136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b9136",
  null
  
)

export default component.exports